import { SourceBasedExpression } from '../Expression.js';
export class RoundExpression extends SourceBasedExpression {
    evaluate(visitor, localVariables) {
        const result = this.getSource().evaluate(visitor, localVariables);
        return Math.round(result);
    }
}
//# sourceMappingURL=RoundExpression.js.map